angular.module('lf.common')

.factory('checkoutService', function ($http, $rootScope, $log, preloadData, siteService) {
  
  var checkoutService = {

    /*
     * This method returns checkout data
     * (same as lf.data["checkoutData"])
     */
	getCheckoutData: function () {
	      return $http({
	        method: 'GET',
	        url: preloadData.getCheckoutDataUrl,
	        params: {}
	      })
	},
		  
    /*
     * This method returns saved creditcards in current ATG profile 
     * (same as lf.data["checkoutData"].paymentData)
     */
	getSavedCreditcards: function () {
	      return $http({
	        method: 'GET',
	        url: preloadData.getSavedCreditcardsUrl,
	        params: {}
	      })
	},

    /*
     * This method returns current saved addresses in ATG profile 
     * (same as lf.data["checkoutData"].shippingData.shippingAddresses)
     */
	getSavedAddresses: function () {
	      return $http({
	        method: 'GET',
	        url: preloadData.getSavedAddressesUrl,
	        params: {}
	      })
	},
    
	/*
     * This method returns a list of applicable shipping methods for the address provided 
     * (same as lf.data["checkoutData"].shippingData.shippingAddresses[n].shippingMethods)
     */
    getShippingOptions: function (params) {
      return $http({
        method: 'GET',
        url: preloadData.shippingOptions,
        params: {
        	address1: params.address1,
        	state: params.state,
        	country: params.country,
        	zipCode: params.zipCode,
        	isCartZipCode: false
        }
      })
    },
    
    /*
     * This method returns shopping cart data along with order details 
     * (same as lf.data.xhr.shop)
     */
	getOrderData: function () {
	      return $http({
	        method: 'GET',
	        url: preloadData.getOrderDataUrl,
	        params: {}
	      })
	},
	
	/*
     * This method submits the user entered address to the backend service that
     * validates and verifies the address and then saves it in current ATG profile. 
     * If setAsDefaultAddress = true is passed, the address is saved as default address 
     * Otherwise, the address is saved as secondary address.
     * 
     */
    addNewShippingAddress: function (params) {
    
    	var postParams = {
    			getData: 'addUpdateShippingAddressResponse',
    	        updateData: 'true',
    	        action: 'addNewShippingAddressAjax',
    	        amplifiHandler: '/atg/userprofiling/ProfileFormHandler'
    		};
    	  postParams['atg_lfAddressForm.data.firstName.value'] = params.firstName;
		  postParams['atg_lfAddressForm.data.lastName.value'] = params.lastName;
		  postParams['atg_lfAddressForm.data.address1.value'] = params.address1;
		  postParams['atg_lfAddressForm.data.address2.value'] = params.address2;
		  postParams['atg_lfAddressForm.data.city.value'] = params.city;
		  postParams['atg_lfAddressForm.data.state.value'] = params.state;
		  postParams['atg_lfAddressForm.data.country.value'] = params.country;
		  postParams['atg_lfAddressForm.data.postalCode.value'] = params.postalCode;
		  postParams['atg_lfAddressForm.data.phoneNumber.value'] = params.phoneNumber;
		  postParams['atg_setAsDefaultAddress'] = params.setAsDefaultAddress;
		  if(typeof params.verifyAddress != undefined) {
			  // verifyAddress is an optional parameter that is passed as "true"
			  // when the address being submitted needs to be verified. [Add New Address]
			  postParams['atg_verifyAddress'] = params.verifyAddress;
		  }
		  if(typeof params.optionOpted != undefined) {
			  // optionOpted is passed only when the user is confirming 
			  // an address selection from experian suggestions
			  postParams['atg_optionOpted'] = params.optionOpted;
		  }
		  
		  return $http({
		    method: 'POST',
			url: lf.data.xhr.shopAction,
			params: postParams, /* params attribute is used to send the form data in query string (URL) */
			headers: {
					/* angular $http by default sends the data passed in "data" or "param" attributes as "application/json"
	    			 * The Content-Type = 'application/x-www-form-urlencoded' header below makes sure that the data is 
	    			 * sent as a String "Name-Value pairs"
	    			 */
					'Content-Type': 'application/x-www-form-urlencoded'
			    }
		  })
    },
    
    /*
     * This method submits the user entered address to the backend service that
     * validates and verifies the address and then saves it in current ATG profile. 
     * If setAsDefaultAddress = true is passed, the address is saved as default address 
     * Otherwise, the address is saved as secondary address.
     * 
     */
    editShippingAddress: function (params) {
    
    	var postParams = {
    			getData: 'addUpdateShippingAddressResponse',
    	        updateData: 'true',
    	        action: 'updateShippingAddressAjax',
    	        amplifiHandler: '/atg/userprofiling/ProfileFormHandler'
    		};
    	  postParams['atg_lfAddressForm.data.firstName.value'] = params.firstName;
		  postParams['atg_lfAddressForm.data.lastName.value'] = params.lastName;
		  postParams['atg_lfAddressForm.data.address1.value'] = params.address1;
		  postParams['atg_lfAddressForm.data.address2.value'] = params.address2;
		  postParams['atg_lfAddressForm.data.city.value'] = params.city;
		  postParams['atg_lfAddressForm.data.state.value'] = params.state;
		  postParams['atg_lfAddressForm.data.country.value'] = params.country;
		  postParams['atg_lfAddressForm.data.postalCode.value'] = params.postalCode;
		  postParams['atg_lfAddressForm.data.phoneNumber.value'] = params.phoneNumber;
		  postParams['atg_value.addressId'] = params.addressId;
		  postParams['atg_value.addressNickName'] = params.addressNickName;
		  if(typeof params.verifyAddress != undefined) {
			  postParams['atg_verifyAddress'] = params.verifyAddress;
		  }
		  if(typeof params.optionOpted != undefined) {
			  // optionOpted is passed only when the user is confirming 
			  // an address selection from experian suggestions. We may not need to pass this.
			  postParams['atg_optionOpted'] = params.optionOpted;
		  }
		  
		  return $http({
		    method: 'POST',
			url: lf.data.xhr.shopAction,
			params: postParams, /* params attribute is used to send the form data in query string (URL) */
			headers: {
				/* angular $http by default sends the data passed in "data" or "param" attributes as "application/json"
    			 * The Content-Type = 'application/x-www-form-urlencoded' header below makes sure that the data is 
    			 * sent as a String "Name-Value pairs"
    			 */
				'Content-Type': 'application/x-www-form-urlencoded'
			   }
		  })
    },
    
    /*
     * This method submits the selected shipping method and shipping address 
     * to the backend service that applies this shipping method to the order 
     */
    applyShippingInformation: function (params) {
    
    	var postParams = {
    			getData: 'standardAjaxResponse',
    	        updateData: 'true',
    	        action: 'applyShippingInfoAjax',
    	        amplifiHandler: '/atg/commerce/order/purchase/PaymentGroupFormHandler'
    		};
    	  postParams['shippingMethodName'] = params.shippingMethodName;
    	  postParams['shippingAddressId'] = params.shippingAddressId;
    	  postParams[params.shippingAddressId + '_address1'] = params.address1;
    	  postParams[params.shippingAddressId + '_address2'] = params.address2;
    	  postParams[params.shippingAddressId + '_city'] = params.city;
    	  postParams[params.shippingAddressId + '_state'] = params.state;
    	  postParams[params.shippingAddressId + '_country'] = params.country;
    	  postParams[params.shippingAddressId + '_postalCode'] = params.postalCode;
    	  postParams[params.shippingAddressId + '_verificationStatus'] = params.verificationStatus;
    	  
		  return $http({
		    method: 'POST',
			url: lf.data.xhr.shopAction,
			params: postParams, /* params attribute is used to send the form data in query string (URL) */
			headers: {
					/* angular $http by default sends the data passed in "data" or "param" attributes as "application/json"
	    			 * The Content-Type = 'application/x-www-form-urlencoded' header below makes sure that the data is 
	    			 * sent as a String "Name-Value pairs"
	    			 */
					'Content-Type': 'application/x-www-form-urlencoded'
			    }
		  })
    },
    
    /*
     * This method submits the selected payment info  
     * to the backend service that applies this payment info to the order 
     */
    applyPaymentInformation: function (params) {
    
    	var postParams = {
    			getData: 'standardAjaxResponse',
    	        updateData: 'true',
    	        action: 'paymentInfo',
    	        amplifiHandler: '/atg/commerce/order/purchase/PaymentGroupFormHandler'
    		};
    	
    	if(typeof params.creditcardId != 'undefined' && params.creditcardId != "") {
    		postParams['atg_savedCreditCardFlow'] = "SAVED_CREDIT_CARD_FLOW";
        	postParams['atg_selectedPaymentMethodId'] = params.creditcardId;
    	}
    	postParams['atg_ajax'] = true;
    	  
    	return $http({
    		method: 'POST',
    		url: lf.data.xhr.shopAction,
    		params: postParams, /* params attribute is used to send the form data in query string (URL) */
    		headers: {
				/* angular $http by default sends the data passed in "data" or "param" attributes as "application/json"
    			 * The Content-Type = 'application/x-www-form-urlencoded' header below makes sure that the data is 
    			 * sent as a String "Name-Value pairs"
    			 */
				'Content-Type': 'application/x-www-form-urlencoded'
		    }
    	})
    }
  }
  
  return checkoutService;
  
});
